import { MicDeadReason } from '@/lib/micHealth/MicHealthMonitor';

export type MicNoSignalReason = MicDeadReason | 'silent-recording';

/**
 * The device delivered no usable audio: the take was dropped instead of being graded, so the learner never
 * scores 0 for a broken mic.
 */
export class MicNoSignalError extends Error {
  readonly reason: MicNoSignalReason;

  constructor(reason: MicNoSignalReason) {
    super('Microphone delivered no signal');
    this.name = 'MicNoSignalError';
    this.reason = reason;
  }
}

export const isMicNoSignalError = (error: unknown): error is MicNoSignalError => error instanceof MicNoSignalError;
